import { ChevronUp, Home } from "lucide-react";
import { Button } from "../../button/button";

type Props = {
  currentPath?: string;
  parentPath?: string;
  isLoading: boolean;
  onNavigate: (path: string) => void;
};

export const DirectoryNav = ({ currentPath, parentPath, isLoading, onNavigate }: Props) => {
  const hasValidPath = currentPath !== undefined && currentPath !== "";
  const canGoUp = !!parentPath && currentPath !== parentPath && !isLoading;

  const handleGoRoot = () => {
    onNavigate("");
  };

  return (
    <div className="flex items-center gap-2 border-b bg-white p-3">
      {hasValidPath && (
        <Button
          variant="ghost"
          size="icon_md"
          onClick={() => parentPath && onNavigate(parentPath)}
          disabled={!canGoUp}
          className="h-9 w-9 shrink-0"
          title="Go Up"
          aria-label="Go Up"
        >
          <ChevronUp className="h-5 w-5" />
        </Button>
      )}
      {!hasValidPath && !isLoading && (
        <Button
          variant="ghost"
          size="icon_md"
          onClick={handleGoRoot}
          disabled={isLoading}
          className="h-9 w-9 shrink-0"
          title="Go to Root"
          aria-label="Go to Root"
        >
          <Home className="h-4 w-4" />
        </Button>
      )}
      <div className="flex-1 truncate rounded border bg-gray-100 px-3 py-2 font-mono text-xs text-gray-600">
        {isLoading ? (
          "Loading..."
        ) : hasValidPath ? (
          currentPath
        ) : (
          <div>
            Unknown path — navigate to root <Home className="inline-block h-4 w-4" />
          </div>
        )}
      </div>
    </div>
  );
};
